/**
 * WelcomeModal
 *
 * Component code for welcome modal functionality
 * Handles cookie-based persistence and GTM integration
 *
 * @since 1.0.0
 */
window.welcomeModal = (cookieDuration) => {
    return {
        cookieDuration: cookieDuration || 30,
        cookieName: 'welcome_modal_dismissed',
        isOpen: false,

        /**
         * Trigger modal to open (called by GTM via custom event).
         * Only opens if cookie hasn't been set.
         * 
         * @author owendixon
         */
        triggerModal() {
            if (!this.hasBeenDismissed()) {
                this.isOpen = true;
                this.disableBodyScroll();
            }
        },

        /**
         * Close the modal and set cookie to prevent showing again.
         * 
         * @author owendixon
         */
        closeModal() {
            this.isOpen = false;
            this.setCookie();
            this.enableBodyScroll();
        },

        /**
         * Check if user has already dismissed the modal.
         * 
         * @returns {boolean}
         * @author owendixon
         */
        hasBeenDismissed() {
            return this.getCookie(this.cookieName) !== null;
        },

        /**
         * Set cookie to remember modal dismissal.
         * Uses pegasus cookie utility function.
         * 
         * @author owendixon
         */
        setCookie() {
            window.pegasus.setCookie(this.cookieName, 'true', this.cookieDuration);
        },

        /**
         * Get cookie value by name.
         * Uses pegasus cookie utility function.
         * 
         * @param {string} name - Cookie name
         * @returns {string|null}
         * @author owendixon
         */
        getCookie(name) {
            const value = window.pegasus.getCookie(name);
            return value ? value : null;
        },

        /**
         * Disable body scroll when modal is open.
         * 
         * @author owendixon
         */
        disableBodyScroll() {
            document.body.style.overflow = 'hidden';
        },

        /**
         * Enable body scroll when modal is closed.
         * 
         * @author owendixon
         */
        enableBodyScroll() {
            document.body.style.overflow = '';
        }
    };
};
